/**
 * breadcrumb.scss
 */

// Import
import "./breadcrumb.scss";
import $ from 'jquery';

$(document).ready(function() {
    $('.lang-item>a').wrapInner('<span>');
});

